var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('p',[_vm._v(" 어울링 앱을 이용해주세요. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }